import * as React from 'react'
import Svg, { Circle, Path, SvgProps } from 'react-native-svg'

export const UserProfile = (props: SvgProps) => (
  <Svg viewBox='0 0 13 13' fill='none' {...props}>
    <Path
      d='M6.57971 7.74536C7.80165 7.74536 8.79223 6.75478 8.79223 5.53284C8.79223 4.31089 7.80165 3.32031 6.57971 3.32031C5.35777 3.32031 4.36719 4.31089 4.36719 5.53284C4.36719 6.75478 5.35777 7.74536 6.57971 7.74536Z'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M10.5625 11V11C10.5625 10.1804 9.89807 9.51595 9.07845 9.51595L4.08146 9.51595C3.26185 9.51595 2.59742 10.1804 2.59742 11V11'
      stroke='currentColor'
    />
    <Circle cx='6.5' cy='6.5' r='6' stroke='currentColor' />
  </Svg>
)
